import "./inline.css.ts.vanilla.css-mistica.js";
var v = "kkfbnv6", k = "kkfbnv5", r = "kkfbnv4", n = "kkfbnv8", b = "kkfbnv9", e = "kkfbnva", f = {
    space: "var(--kkfbnv0)",
    spaceMobile: "var(--kkfbnv1)",
    spaceTablet: "var(--kkfbnv2)",
    spaceDesktop: "var(--kkfbnv3)"
}, i = "kkfbnv7";
export { v as fullWidth, k as inline, r as marginInline, n as noFullWidth, b as stringSpace, e as stringSpaceWithWrap, f as vars, i as wrap };
